
import { ArrowRight, BarChart3, Mail, Scale } from 'lucide-react'
import { Link } from 'react-router-dom'

export function About(){return <>
  <section className="public-page-hero public-container">
    <span className="public-kicker">About Mail Percent</span>
    <h1>Mail Percent makes customer email operations measurable.</h1>
    <p>
      Mail Percent gives organisations a measurable view of the work between customer email arriving and a response being sent, with workload context kept alongside performance.
    </p>
  </section>

  <section className="public-section public-container">
    <div className="about-principles">
      <div>
        <Mail/>
        <h3>Customer email is operational work.</h3>
        <p>Leads, questions, complaints, renewals and ongoing relationships all move through email. Mail Percent gives that work an operating layer.</p>
      </div>

      <div>
        <BarChart3/>
        <h3>Measure the stages that matter.</h3>
        <p>Measure response time, queue pressure, workload and SLA Performance rather than relying on a single volume number.</p>
      </div>

      <div>
        <Scale/>
        <h3>Keep accountability fair.</h3>
        <p>Track standards and individual responsibility while keeping volume, backlog, staffing and complexity visible so the right problem gets fixed.</p>
      </div>
    </div>
  </section>

  <section className="public-section public-soft-section">
    <div className="public-container public-final-cta">
      <div>
        <span className="public-kicker">Build a stronger customer email operation</span>
        <h2>See the gaps before they cost you a customer.</h2>
        <p>Create your organisation, connect a supported mailbox and start building a clearer picture of customer email follow-through.</p>
      </div>
      <Link to="/signup" className="button primary public-cta">Get started <ArrowRight size={16}/></Link>
    </div>
  </section>
</>}
